import React from "react";
import ReactDOM from "react-dom/client";
import "./main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import { Provider } from "react-redux";
import storeConfiguration from "./storeConfiguration";
import { HelmetProvider } from "react-helmet-async";
import initializeSentry from "./infrastructure/Sentry";

Amplify.configure({
  Auth: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  },
});

const store = storeConfiguration();
const root = ReactDOM.createRoot(document.getElementById("root"));

initializeSentry();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
